// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--syCRb";
export var sections = "footer-module--sections--1Iedj";
export var section = "footer-module--section--1Xs1I";
export var bottom = "footer-module--bottom--3r07x";
export var request = "footer-module--request--mWdJP";
export var key = "footer-module--key--3S0XW";
export var value = "footer-module--value--3vzKZ";